import { render, staticRenderFns } from "./OrganizationsDetails.vue?vue&type=template&id=0b8a845f"
import script from "./OrganizationsDetails.vue?vue&type=script&lang=js"
export * from "./OrganizationsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports